import { render, staticRenderFns } from "./FolderCreateDialog.vue?vue&type=template&id=39f0a96f"
import script from "./FolderCreateDialog.vue?vue&type=script&lang=js"
export * from "./FolderCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports